import * as React from 'react'

import Baseline from '@eversports/klimt-design-components/Baseline'
import ThemeProvider from '@eversports/klimt-design-components/ThemeProvider'
import theme from '@eversports/klimt-design-components/theme'

const CompactKlimtWrapper = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <ThemeProvider theme={theme}>
      <Baseline />
      {children}
    </ThemeProvider>
  )
}

export default CompactKlimtWrapper
